import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/task/hierarchy/styles.scss';export default {
  "hierarchy": "_hierarchy_1tpl3_1"
};